import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import "./Accordion.scss";

export class Accordion extends React.Component {
  static defaultProps = {};

  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Id associated with component */
    id: PropTypes.any,
    /** Label associated with component */
    label: PropTypes.string,
    /** A List of AccordionItem JSX objects to be rendered */
    children: PropTypes.node,
  };

  render() {
    const { children, className, id, label } = this.props;
    const accordionClass = classNames("accordion", className);

    return (
      <div className={accordionClass} id={id} label={label}>
        {children}
      </div>
    );
  }
}

export default Accordion;
